<template>
  <div class="container-main">
    <div class="container-main-header-button">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span v-if="this.$route.params.id">Редактирование опроса</span>
      <span v-else>Добавление опроса</span>
    </div>
    <v-form ref="formFirst">
      <div class="container-block">
        <div class="container-block-title" style="margin-top: 0">
          Основная информация
        </div>
        <div>
          <v-text-field
            label="Заголовок"
            required
            type="text"
            outlined
            :rules="rules"
            counter
            v-model="item.title"
            maxlength="100"
          ></v-text-field>
        </div>
        <div>
          <v-textarea
            no-resize
            rows="3"
            label="Вопрос"
            required
            type="text"
            outlined
            :rules="rules"
            v-model="item.question"
          ></v-textarea>
        </div>
        <div>
          <v-textarea
            no-resize
            rows="3"
            label="Описание"
            required
            type="text"
            outlined
            v-model="item.description"
          ></v-textarea>
        </div>
        <div>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="newDate"
                outlined
                readonly
                label="Дата завершения"
                v-bind="attrs"
                v-on="on"
                clearable
                ref="date_input"
              ></v-text-field>
            </template>
            <v-card class="d-flex">
              <div class="d-flex">
                <v-date-picker
                  locale="ru-Ru"
                  color="var(--app-dark-blue-1)"
                  v-model="pickDate"
                  first-day-of-week="1"
                ></v-date-picker>
                <v-time-picker
                  format="24hr"
                  color="var(--app-dark-blue-1)"
                  scrollable
                  :disabled="!pickDate"
                  v-model="pickDateTime"
                  width="290"
                ></v-time-picker>
              </div>
            </v-card>
          </v-menu>
        </div>
      </div>
    </v-form>
    <div class="container-block">
      <div class="container-block-title">
        Параметры публикации и отображения
      </div>
      <div class="d-flex align-center mt-4">
        <v-switch
          v-model="item.isOnlyForAuthorizedUsers"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label"
          >Доступно прохождение только авторизованным пользователям</span
        >
      </div>
      <div class="d-flex align-center mt-4">
        <v-switch
          v-model="item.toSendPush"
          hide-details
          color="var(--app-green-1)"
        ></v-switch>
        <span class="switch-label"
          >Рассылка уведомления при публикации опроса</span
        >
      </div>
    </div>
    <div v-if="!newImage" class="container-block">
      <div class="container-block-title">Главное изображение</div>

      <v-file-input
        accept="image/*"
        outlined
        :rules="[
          (value) =>
            (value && value.size < 104857600) ||
            'Размер изображения не больше 100 мб',
        ]"
        hint="Максимальный размер изображения 100 мб"
        persistent-hint
        v-model="newImage"
        @change="previewImage"
        label="Прикрепить изображение"
      ></v-file-input>
      <div class="container-block-gallery-button">
        Выбрать изображение из галереи
      </div>
    </div>

    <div v-if="!newImageMini" class="container-block">
      <div class="container-block-title">Изображение внутри опроса</div>

      <v-file-input
        accept="image/*"
        outlined
        hint="Максимальный размер изображения 100 мб"
        persistent-hint
        v-model="newImageMini"
        @change="previewImageMini"
        label="Прикрепить изображение"
      ></v-file-input>
      <div class="container-block-gallery-button">
        Выбрать изображение из галереи
      </div>
    </div>
    <div
      v-if="newImage || newImageMini"
      class="container-block"
      style="width: 100%"
    >
      <div class="container-block-title">Изображения</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Для смартфонов</th>
              <th class="text-left">Для планшетов</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px" v-if="newImage">
              <td class="text-left">Главное изображение</td>
              <td class="text-left">Отображается на всплывающем окне</td>
              <td class="text-left">
                <v-btn
                  v-if="!finishImageMobile"
                  @click="openMobileImg(false)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img
                    @click="openMobileImg(false)"
                    class="table-img"
                    :src="finishImageMobile"
                  />
                  <v-btn
                    outlined
                    @click="openMobileImg(false)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn
                  v-if="!finishImageTablet"
                  @click="openTabletImg(false)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img
                    @click="openTabletImg(false)"
                    class="table-img"
                    :src="finishImageTablet"
                  />
                  <v-btn
                    outlined
                    @click="openTabletImg(false)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImage">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
            <tr style="height: 60px" v-if="newImageMini">
              <td class="text-left">Изображение внутри опроса</td>
              <td class="text-left">Изображение внутри опроса</td>
              <td class="text-left">
                <v-btn
                  v-if="!finishImageMobileMini"
                  @click="openMobileImg(true)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img
                    @click="openMobileImg(true)"
                    class="table-img"
                    :src="finishImageMobileMini"
                  />
                  <v-btn
                    outlined
                    @click="openMobileImg(true)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn
                  v-if="!finishImageTabletMini"
                  @click="openTabletImg(true)"
                  class="button-accept"
                  style="width: auto !important"
                >
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img
                    @click="openTabletImg(true)"
                    class="table-img"
                    :src="finishImageTabletMini"
                  />
                  <v-btn
                    outlined
                    @click="openTabletImg(true)"
                    color="var(--app-dark-blue-1) "
                    class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px"
                  >
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImageMini">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Откадрируйте изображения для всех типов устройств
      </v-alert>
      <v-divider></v-divider>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrc"
        v-model="dialogMobile"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobile = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper
                  ref="cropperMobail"
                  :src="imgSrc"
                  style="width: 450px; height: 450px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :stencil-size="{
                    width: 343,
                    height: 173,
                  }"
                  image-restriction="stencil"
                  @change="onChangeMobile"
                />
              </div>

              <div v-if="resultImageMobile">
                <img
                  width="343px"
                  height="173px"
                  style="margin-left: 30px"
                  :src="resultImageMobile"
                />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrcMini"
        v-model="dialogMobileMini"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobileMini = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrcMini" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper
                  ref="cropperMobailMini"
                  :src="imgSrcMini"
                  style="width: 450px; height: 450px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :stencil-size="{
                    width: 343,
                    height: 206,
                  }"
                  image-restriction="stencil"
                  @change="onChangeMobileMini"
                />
              </div>

              <div
                style="width: 100%"
                class="d-flex justify-center"
                v-if="resultImageMobileMini"
              >
                <img
                  width="343px"
                  height="206px"
                  :src="resultImageMobileMini"
                />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImgMini()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrc"
        v-model="dialogTablet"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTablet = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="">
              <div style="width: 100%; height: 200px">
                <cropper
                  ref="cropperTablet"
                  :src="imgSrc"
                  style="width: 100%; height: 300px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :stencil-size="{
                    width: 658,
                    height: 374,
                  }"
                  image-restriction="stencil"
                  @change="onChangeTablet"
                />
              </div>

              <div class="dialog-tablet-img" v-if="resultImageTablet">
                <img width="658px" height="374px" :src="resultImageTablet" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        width="800px"
        height="auto"
        persistent
        v-if="imgSrcMini"
        v-model="dialogTabletMini"
      >
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTabletMini = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrcMini" class="">
              <div style="width: 100%; height: 200px">
                <cropper
                  ref="cropperTabletMini"
                  :src="imgSrcMini"
                  style="width: 100%; height: 300px"
                  :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }"
                  :stencil-size="{
                    width: 658,
                    height: 374,
                  }"
                  image-restriction="stencil"
                  @change="onChangeTabletMini"
                />
              </div>

              <div class="dialog-tablet-img" v-if="resultImageTabletMini">
                <img
                  width="658px"
                  height="374px"
                  :src="resultImageTabletMini"
                />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImgMini()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div class="container-block">
      <div class="container-block-title" style="margin-bottom: 0px !important">
        Варианты ответов
      </div>
      <div>
        Отметьте галочкой правильный ответ, если правильного ответа нет, не
        отмечайте ничего
      </div>
      <div class="container-block-input-items">
        <v-form ref="formSecond">
          <div class="items-block" v-for="i in answers" :key="i.idNew">
            <div class="block-checkbox">
              <v-checkbox
                v-model="i.isCorrect"
                hide-details
                @change="changeCheck($event, i)"
                color="#3952D1"
              ></v-checkbox>
            </div>
            <v-text-field
              label="Вариант"
              required
              type="text"
              outlined
              :rules="rules"
              v-model="i.text"
            ></v-text-field>
            <div
              class="block-close"
              v-if="answers && answers.length > 1"
              @click="deleteAnswer(i)"
            >
              <v-icon>mdi-close</v-icon>
            </div>
          </div>
        </v-form>
        <div @click="addAnswer" class="container-block-gallery-button ml-11">
          Добавить вариант
        </div>
      </div>
    </div>

    <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
      Прикрепите изображение
    </v-alert>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn
          :loading="sendForm"
          @click="saveItem"
          style="width: auto !important"
          class="button-accept"
        >
          Сохранить
        </v-btn>
      </div>
      <div>
        <v-btn
          :disabled="sendForm"
          @click="dialogDelete = true"
          v-if="item.id"
          outlined
          style="width: auto !important"
          color="var(--app-red-1)"
          class="button-accept-outlined"
        >
          Удалить
        </v-btn>
      </div>
    </div>
    <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите удалить опрос?</span>
          <v-icon @click="dialogDelete = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-actions class="dialog-buttons">
          <v-btn
            @click="dialogDelete = false"
            style="width: 120px"
            outlined
            color="var(--app-green-1)"
          >
            Нет
          </v-btn>
          <v-btn
            @click="deleteItem"
            style="width: 120px"
            outlined
            color="var(--app-red-1)"
          >
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
export default {
  components: {
    Cropper,
  },
  data: () => ({
    item: { id: "", isOnlyForAuthorizedUsers: false, toSendPush: false },
    rules: [(value) => !!value || "Обязательно к заполнению"],
    formData: new FormData(),
    errImages: false,
    errImagesMain: false,

    newImage: null,
    newImageMini: null,

    imgSrc: "",
    imgSrcMini: "",

    resultImageMobile: "",
    resultImageTablet: "",

    finishImageMobile: "",
    finishImageTablet: "",

    resultImageMobileMini: "",
    resultImageTabletMini: "",

    finishImageMobileMini: "",
    finishImageTabletMini: "",

    smartphoneMainImage: null,
    tabletMainImage: null,

    smartphoneMiniImage: null,
    tabletMiniImage: null,

    dialogMobile: false,
    dialogMobileMini: false,
    dialogTablet: false,
    dialogTabletMini: false,
    dialogDelete: false,
    answers: [
      {
        text: "",
        isCorrect: false,
        idNew: Math.floor(Math.random() * 1000),
      },
    ],
    sendForm: false,
    menu: false,
    newDate: null,
    pickDate: null,
    pickDateTime: "00:00",
  }),
  methods: {
    onChangeMobile({ canvas }) {
      this.resultImageMobile = canvas.toDataURL();
    },
    onChangeMobileMini({ canvas }) {
      this.resultImageMobileMini = canvas.toDataURL();
    },
    onChangeTablet({ canvas }) {
      this.resultImageTablet = canvas.toDataURL();
    },
    onChangeTabletMini({ canvas }) {
      this.resultImageTabletMini = canvas.toDataURL();
    },
    closeTabletImg() {
      this.finishImageTablet = this.resultImageTablet;
      this.dialogTablet = false;
      const { canvas } = this.$refs.cropperTablet.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("tabletMainImage")) {
            this.formData.delete("tabletMainImage");
          }
          this.formData.append("tabletMainImage", blob);
        },
        "image/webp",
        0.95
      );
      this.tabletMainImage = true;
    },
    closeTabletImgMini() {
      this.finishImageTabletMini = this.resultImageTabletMini;
      this.dialogTabletMini = false;
      const { canvas } = this.$refs.cropperTabletMini.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("tabletInternalImage")) {
            this.formData.delete("tabletInternalImage");
          }
          this.formData.append("tabletInternalImage", blob);
        },
        "image/webp",
        0.95
      );
      this.tabletMiniImage = true;
    },
    closeMobileImg() {
      this.finishImageMobile = this.resultImageMobile;
      this.dialogMobile = false;
      const { canvas } = this.$refs.cropperMobail.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("smartphoneMainImage")) {
            this.formData.delete("smartphoneMainImage");
          }
          this.formData.append("smartphoneMainImage", blob);
        },
        "image/webp",
        0.95
      );
      this.smartphoneMainImage = true;
    },
    closeMobileImgMini() {
      this.finishImageMobileMini = this.resultImageMobileMini;
      this.dialogMobileMini = false;
      const { canvas } = this.$refs.cropperMobailMini.getResult();

      canvas.toBlob(
        (blob) => {
          if (this.formData.get("smartphoneInternalImage")) {
            this.formData.delete("smartphoneInternalImage");
          }
          this.formData.append("smartphoneInternalImage", blob);
        },
        "image/webp",
        0.95
      );
      this.smartphoneMiniImage = true;
    },
    openMobileImg(mini) {
      if (mini) {
        this.dialogMobileMini = true;
        setTimeout(() => {
          this.$refs.cropperMobailMini.refresh();
        }, 500);
      } else {
        this.dialogMobile = true;
        setTimeout(() => {
          this.$refs.cropperMobail.refresh();
        }, 500);
      }

      this.errImages = false;
    },
    openTabletImg(mini) {
      if (mini) {
        this.dialogTabletMini = true;
        setTimeout(() => {
          this.$refs.cropperTabletMini.refresh();
        }, 500);
      } else {
        this.dialogTablet = true;
        setTimeout(() => {
          this.$refs.cropperTablet.refresh();
        }, 500);
      }

      this.errImages = false;
    },
    previewImage() {
      if (this.newImage) {
        this.imgSrc = URL.createObjectURL(this.newImage);
      } else {
        this.imgSrc = "";
      }
    },
    previewImageMini() {
      if (this.newImageMini) {
        this.imgSrcMini = URL.createObjectURL(this.newImageMini);
      } else {
        this.imgSrcMini = "";
      }
    },
    back() {
      if (this.$route.params.id) {
        this.$router.push({
          name: "PollDetail",
          params: { id: this.$route.params.id },
        });
      } else {
        this.$router.push({ name: "Polls" });
      }
    },
    getItem() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV3 + "/poll", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            pollId: this.$route.params.id,
          },
        })
        .then((res) => {
          this.item = res.data;

          if (this.item.internalImage) {
            this.newImageMini = true;
            this.imgSrcMini = this.item.internalImage;
          }
          if (this.item.mainImage) {
            this.newImage = true;
            this.imgSrc = this.item.mainImage;
          }
          this.smartphoneMainImage = this.item.smartphoneMainImage;
          this.smartphoneMiniImage = this.item.smartphoneInternalImage;

          this.tabletMainImage = this.item.tabletMainImage;
          this.tabletMiniImage = this.item.tabletInternalImage;

          this.item.smartphoneMainImage
            ? (this.finishImageMobile = this.item.smartphoneMainImage)
            : "";
          this.item.smartphoneInternalImage
            ? (this.finishImageMobileMini = this.item.smartphoneInternalImage)
            : "";

          this.item.tabletMainImage
            ? (this.finishImageTablet = this.item.tabletMainImage)
            : "";
          this.item.tabletInternalImage
            ? (this.finishImageTabletMini = this.item.tabletInternalImage)
            : "";
          if (this.item.answers && this.item.answers.length > 0) {
            this.answers = this.item.answers.map((i) => {
              const newObj = {
                text: i.text,
                isCorrect: i.isCorrect,
                idNew: Math.floor(Math.random() * 1000),
                id: i.id,
              };
              return newObj;
            });
          }
          if (this.item.dateEnd) {
            const date = new Date(this.item.dateEnd);
            this.pickDate = new Date(
              this.item.dateEnd - date.getTimezoneOffset() * 60000
            )
              .toISOString()
              .substr(0, 10);
            let hour = date.getHours();
            let minute = date.getMinutes();
            if (hour < 10) {
              hour = `0${hour}`;
            }
            if (minute < 10) {
              minute = `0${minute}`;
            }
            this.pickDateTime = `${hour}:${minute}`;
          }
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    deleteImage() {
      this.newImage = null;
      this.imgSrc = "";
      this.resultImageMobile = "";
      this.resultImageTablet = "";
      this.finishImageMobile = "";
      this.finishImageTablet = "";
      this.smartphoneMainImage = null;
      this.tabletMainImage = null;
    },
    deleteImageMini() {
      this.newImageMini = null;
      this.imgSrcMini = "";
      this.resultImageMobileMini = "";
      this.resultImageTabletMini = "";
      this.finishImageMobileMini = "";
      this.finishImageTabletMini = "";
      this.smartphoneMiniImage = null;
      this.tabletMiniImage = null;
    },
    changeCheck(bool, item) {
      this.answers = this.answers.map((i) => {
        if (item.idNew == i.idNew) {
          i.isCorrect = bool;
        } else {
          i.isCorrect = false;
        }
        return i;
      });
    },
    deleteAnswer(item) {
      this.answers = this.answers.filter((i) => i.idNew != item.idNew);
    },
    addAnswer() {
      this.answers.push({
        text: "",
        isCorrect: false,
        idNew: Math.floor(Math.random() * 1000),
      });
    },
    saveItem() {
      if (this.$refs.formFirst.validate()) {
        if (this.newImage) {
          if (this.smartphoneMainImage && this.tabletMainImage) {
            this.errImages = false;
            if (this.$refs.formSecond.validate()) {
              const newArr = this.answers.map((i) => {
                const newObj = {
                  text: i.text,
                  isCorrect: i.isCorrect,
                  id: i.id ? i.id : "",
                };
                return newObj;
              });

              if (this.newDate) {
                const validDate = this.pickDate + "T" + this.pickDateTime;
                const date = new Date(validDate).getTime();
                this.formData.append("dateEnd", date);
              } else {
                this.formData.append("dateEnd", null);
              }

              if (this.item.id) {
                this.formData.append("pollId", this.item.id);
              }
              this.formData.append("title", this.item.title);
              this.formData.append("question", this.item.question);
              this.formData.append("description", this.item.description || "");
              this.formData.append(
                "isOnlyForAuthorizedUsers",
                this.item.isOnlyForAuthorizedUsers
              );
              this.formData.append("toSendPush", this.item.toSendPush);
              this.formData.append("answers", JSON.stringify(newArr));
              this.formData.append("mainImage", this.newImage || null);
              this.formData.append("internalImage", this.newImageMini || null);
              this.sendForm = true;
              this.$axios
                .post(
                  this.$store.getters[
                    this.item.id ? "apiAdminPanelV3" : "apiAdminPanelV5"
                  ] + "/poll",
                  this.formData,
                  {
                    headers: {
                      authorization: this.$store.getters.adminPanelHeaderAuth,
                      "secret-key": this.$store.state.secretKeyCookie,
                    },
                  }
                )
                .then(() => {
                  if (this.item.id) {
                    this.$router.push({
                      name: "PollDetail",
                      params: { id: this.$route.params.id },
                    });
                  } else {
                    this.sendForm = false;
                    this.$router.push({ name: "Polls" });
                  }
                })
                .catch((err) => {
                  this.sendForm = false;
                  this.$store.commit("errorSet", true);
                  this.$store.commit("errorTextSet", err);
                });
            }
          } else {
            this.errImages = true;
          }
        } else {
          this.errImagesMain = true;
        }
      }
    },
    deleteItem() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV3 + "/poll", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            pollId: this.$route.params.id,
          },
        })
        .then(() => {
          this.$router.push({ name: "Polls" });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
  },
  watch: {
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
    pickDate() {
      const date = this.formatDate(this.pickDate);
      this.newDate = date + " " + this.pickDateTime;
    },
    pickDateTime() {
      if (this.pickDate) {
        const date = this.formatDate(this.pickDate);
        this.newDate = date + " " + this.pickDateTime;
      }
    },
    // newImageMini() {
    //   if (this.newImageMini) {
    //     this.errImagesMain = false;
    //   }
    // },
  },
  created() {
    if (this.$route.params.id && this.$route.params.id != "create") {
      this.getItem();
    }
  },
};
</script>
<style lang="scss" scoped>
.container-main {
  box-sizing: border-box;
  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
      margin-top: 30px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      height: 38px;
      object-fit: contain;
    }

    .container-block-input-items {
      margin-top: 24px;

      .items-block {
        display: flex;

        // align-items: center;
        .block-checkbox {
          margin-top: 16px;
          margin-right: 12px;
        }

        .block-close {
          margin-top: 16px;
          margin-left: 12px;
          cursor: pointer;
        }
      }
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}
</style>
